import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

import { environment } from 'environments/environment';

import { Intervention } from './intervention.class';

import { Observable } from 'rxjs/Observable';

const BASE_PATH = '/ws/app/intervention';
const BASE_URL = `${environment.API_URL}${BASE_PATH}`;

@Injectable()
export class InterventionService {

  constructor(
    public http: HttpClient
  ) {}

  public get(id): Observable<Intervention> {
    return this.http.get(`${BASE_URL}/${id}`)
      .map((interventionData) => new Intervention(interventionData));
  }

  // public create(intervention: Intervention): Observable<Intervention> {
  //   return this.http.post(BASE_URL, intervention)
  //     .map((interventionData) => new Intervention(interventionData));
  // }

  public update(intervention: Intervention): Observable<any> {
    return this.http.put(`${BASE_URL}/${intervention.id}`, intervention);
  }

  public remove(id: string): Observable<any> {
    return this.http.delete(`${BASE_URL}/${id}`);
  }

  public all(): Observable<Intervention[]> {
    return this.http.get(BASE_URL)
      .map((listInterventionData) =>
        (listInterventionData as any[]).map((interventionData) => new Intervention(interventionData))
      );
  }

  public getImageUri(interventionId: string, imageId: string): string {
    return `${environment.API_URL}/ws/app/intervention/${interventionId}/picture/${imageId}`;
  }

  public getPdfUri(id: string): string {
    return `${BASE_URL}/${id}/pdf`;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/intervention.service.ts